// AllProductDialog.js
import {
    defineComponent,
    ref,
    computed,
    watch,
    inject,
    nextTick,
} from "/Scripts/vue.esm-browser.js";
const html = String.raw;
import SortBox from "/Component/Shop/filter/SortBox.js";
import CardWrap from "/Component/Shop/product/CardWrap.js";
import Pagination from "/Component/Shop/filter/Pagination.js";
export default defineComponent({
    name: "AllProductDialog",
    components: {
        SortBox,
        CardWrap,
        Pagination,
    },
    emits: [],
    setup(props, { emit }) {
        const allProductPopup = inject("allProductPopup", ref(false));
        const allProductData = inject("allProductData");
        const compareGroups = inject("compareGroups");
        const modalContentRef = ref(null);
        const isVisible = ref(false);
        const isActive = ref(false);
        const modalBodyRef = ref(null);

        const maxCount = inject("maxCount");
        const nowPage = inject("nowPage");

        //依照頁碼處理要顯示的資料
        const pagedData = computed(() => {
            const startIndex = (nowPage.value - 1) * maxCount.value;
            const endIndex = startIndex + maxCount.value;
            return allProductData.value.items.slice(startIndex, endIndex);
        });
        const handleOverlayClick = (e) => {
            // 如果點擊的是 modal 外部，就關閉
            if (modalContentRef.value && !modalContentRef.value.contains(e.target)) {
                allProductPopup.value = false;
            }
        };

        watch(
            () => allProductPopup.value,
            async (newVal) => {
                if (newVal) {
                    isVisible.value = true;
                    await nextTick();
                    setTimeout(() => {
                        isActive.value = true;
                        BindCompareButton(compareGroups.value);
                    }, 2);
                } else {
                    isActive.value = false;
                    setTimeout(() => {
                        isVisible.value = false;
                    }, 400);
                }
                await nextTick(); // 等畫面更新完
                if (modalBodyRef.value) {
                    modalBodyRef.value.scrollTop = 0; // 瞬間移動
                }
            },
            { immediate: true }
        );

        watch(
            () => nowPage.value,
            async () => {
                await nextTick(); // 等畫面更新完
                if (modalBodyRef.value) {
                    modalBodyRef.value.scrollTop = 0; // 瞬間移動
                }
            }
        );


        return {
            isVisible,
            isActive,
            allProductPopup, // 如果你也要讓 popup 裡面可以按鈕關閉
            allProductData,
            pagedData,
            modalBodyRef,
            modalContentRef,
            handleOverlayClick

        };
    },
    template: html`
        <div
            class="allProduct_dialog Com_PopupBg"
            :style="{ display: isVisible ? 'block' : 'none' }"
            :class="{ active: isActive }"
            @click="handleOverlayClick"
        >
            <div class="modal-content Com_halfPopup" ref="modalContentRef">
                <div class="modal_header">
                    <h1>依出發日期</h1>
                    <button class="close_btn" @click="allProductPopup = false">
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.8 28L0 25.2L11.2 14L0 2.8L2.8 0L14 11.2L25.2 0L28 2.8L16.8 14L28 25.2L25.2 28L14 16.8L2.8 28Z"
                                fill="#8A8A8A"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div class="modal_body scrollbarWidth" ref="modalBodyRef">
                    <div class="title_block">
                        <div class="title_block_title">
                            <div class="title">{{allProductData.subArea}}</div>
                            <div
                                class="title_2"
                                v-if="allProductData.otherAreaName || allProductData.departure"
                            >
                                <strong>
                                    {{allProductData.otherAreaName}}
                                </strong>
                                <template v-if="allProductData.departure">
                                - {{allProductData.departure}}出發
                                </template>
                            </div>
                        </div>

                        <Sort-Box></Sort-Box>
                    </div>
                    <div class="product_region scrollbarWidth">
                        <card-wrap
                            :items="pagedData"
                            :groupShowType="'uni'"
                            :isAllProduct="true"
                        />
                        <Pagination :data="allProductData.items"></Pagination>
                    </div>
                </div>
            </div>
        </div>
    `,
    methods: {},
});
